// extracted by mini-css-extract-plugin
export default {"cont":"NoData_cont__l0WwK"};